import { Injectable } from '@angular/core';
import olMap from 'ol/Map';
import { unByKey } from 'ol/Observable';
import {toLonLat} from 'ol/proj';
import { CoordenateService } from './coordenate.service';
import { MapService } from './map.service';

@Injectable({
  providedIn: 'root'
})
export class WebBrowserMapService {

  dblClickListener;
  map: olMap;
  mapType : string;

  constructor(private mapService : MapService,
    private rcsControl: CoordenateService
    ) {
    this.map = mapService.getMap("map");
  }

  openWindow(mapType : string){
    this.mapType = mapType;
    this.clearListeners();
    this.dblClickListener = this.map.on("dblclick", this.dblClickHandler.bind(this));
  }

  dblClickHandler(evt) {
    const coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
    const lat = coords[1];
    const lon = coords[0];
    const mapZoom = this.map.getView().getZoom();

    const coordStr: string = lat + "," + lon;

    const str: string = `http://maps.google.com/maps?q=${coordStr}&ll=${coordStr}&z=${mapZoom}&t=${this.mapType == "Satellite" ? "k" : "m"}`;
    
    window.open(str, '_blank').focus();
    this.clearListeners();
  }

  clearListeners() {
    unByKey(this.dblClickListener);
    this.map.removeEventListener("dblclick", null);
  }


}
